// extracted by mini-css-extract-plugin
export default {"main":"App_main_TQMSS","messageNumber":"App_messageNumber_dh35Q","boxShadow":"App_boxShadow_RGTfj"};